module.exports = __webpack_public_path__ + "media/images/23february(md)-8ddaf4c2c2877266654121b6a0ebe4cf.jpg";